import type { SOCSampleWithDocuments } from '../../../types/apiModels'
import { apiClient } from '../../ruutsApi/client'
import endpoints from '../../ruutsApi/endpoints'
import { unwrapCollection } from '../../ruutsApi/normalize'

export const getSOCSamples = async ({
  farmId,
  signal,
}: {
  farmId: string
  signal?: AbortSignal
}): Promise<SOCSampleWithDocuments[]> => {
  const response = await apiClient.get(endpoints.monitoringSOCSamples, {
    params: { farmId },
    signal,
  })
  const items = unwrapCollection<SOCSampleWithDocuments>(response)
  return items.sort((a, b) => (a.samplingNumberId ?? 0) - (b.samplingNumberId ?? 0))
}
